import request from '@/utils/request'

// 任务列表接口
export function workList(params) {
  return request({ url: '/taxapi/tax/workList', method: 'get', params })
}

// 任务详情
export function workDetail(params) {
  return request({ url: '/taxapi/tax/workDetail', method: 'get', params })
}
